import {
  buildFixedCabinMarkupRows,
  bundleCabinMarkupRowsToApi,
  mergeFixedCabinMarkupRows,
} from './bundle-cabin-markup-form-utils';
import type {
  BundleCabinMarkupFormRow,
  BundleEligibilityType,
  BundleType,
  CruiseBundle,
  CruiseBundleCreate,
} from './types';

export const BUNDLE_TYPES = {
  IN_FLOW_SELECTION: 'IN_FLOW_SELECTION',
  PRECONFIGURED: 'PRECONFIGURED',
} satisfies Record<BundleType, BundleType>;

export const BUNDLE_ELIGIBILITY_TYPES = {
  ALL_NET_RATES: 'ALL_NET_RATES',
  EXPLICIT_RATES: 'EXPLICIT_RATES',
} satisfies Record<BundleEligibilityType, BundleEligibilityType>;

export type BundleFormState = Omit<Partial<CruiseBundle>, 'savingsAmount' | 'type' | 'eligibilityType'> & {
  type: BundleType;
  eligibilityType: BundleEligibilityType;
  savingsAmount?: number | null | '';
  cabinMarkupRows: Array<BundleCabinMarkupFormRow>;
};

export function getBundleFormState(bundle?: CruiseBundle): BundleFormState {
  return {
    name: bundle?.name ?? '',
    type: bundle?.type ?? BUNDLE_TYPES.IN_FLOW_SELECTION,
    eligibilityType: bundle?.eligibilityType ?? BUNDLE_ELIGIBILITY_TYPES.ALL_NET_RATES,
    savingsAmount: bundle?.savingsAmount ?? null,
    termsAndConditions: bundle?.termsAndConditions ?? null,
    startDate: bundle?.startDate ?? null,
    endDate: bundle?.endDate ?? null,
    fkVendorId: bundle?.fkVendorId ?? null,
    cabinMarkupRows: bundle ? mergeFixedCabinMarkupRows(bundle.cabinTypeMarkups ?? []) : buildFixedCabinMarkupRows(),
  };
}

export function changeBundleFormType(fields: BundleFormState, type: BundleType): BundleFormState {
  return {
    ...fields,
    type,
    eligibilityType:
      type === BUNDLE_TYPES.IN_FLOW_SELECTION
        ? BUNDLE_ELIGIBILITY_TYPES.ALL_NET_RATES
        : BUNDLE_ELIGIBILITY_TYPES.EXPLICIT_RATES,
    savingsAmount: null,
    cabinMarkupRows: buildFixedCabinMarkupRows(),
  };
}

export function bundleFormToApi(fields: BundleFormState): Omit<CruiseBundleCreate, 'fkVendorId'> {
  const isPreconfigured = fields.type === BUNDLE_TYPES.PRECONFIGURED;
  return {
    name: fields.name || '',
    type: fields.type,
    eligibilityType: fields.eligibilityType,
    // Legacy bundle.markup column; preconfigured pricing uses cabinTypeMarkups.
    markup: 0,
    savingsAmount: isPreconfigured && fields.savingsAmount !== '' ? (fields.savingsAmount ?? null) : null,
    termsAndConditions: fields.termsAndConditions || null,
    startDate: fields.startDate || '',
    endDate: fields.endDate || '',
    cabinTypeMarkups: isPreconfigured ? bundleCabinMarkupRowsToApi(fields.cabinMarkupRows) : [],
  };
}
